import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { KeeniconComponent } from '../../../../../keenicon/keenicon.component';
import { AdminService } from '../../../../../../services/admin.service';
import { TranslateModule } from '@ngx-translate/core';
@Component({
	selector: 'app-sidebar-menu',
	templateUrl: './sidebar-menu.component.html',
	styleUrls: ['./sidebar-menu.component.scss'],
	imports: [CommonModule, RouterModule, KeeniconComponent, TranslateModule],
	standalone: true,
})
export class SidebarMenuComponent {
	private router = inject(Router);
	private adminService = inject(AdminService);
	isAdmin = false;

	constructor() {
		this.adminService.isLoyaltyAdmin$.subscribe((isAdmin) => {
			this.isAdmin = isAdmin;
		});
	}

	navigateTo(route: string) {
		this.router.navigate([route]);
	}
}
